import { Schema } from '@togglecorp/ravl';

const dailyLogSchema: Schema[] = [];

{
    const schema = {
        doc: {
            name: 'dailyLog',
            description: 'Data for daily log',
        },
        fields: {
            id: { type: 'uint', required: true },
            checkIn: { type: 'string', required: true },
            checkOut: { type: 'string', required: false },
            duration: { type: 'uint', required: false },
            totalDuration: { type: 'uint', required: true },
            offsiteDuration: { type: 'uint', required: true },
            user: { type: 'uint', required: true },
            offsiteMeetings: { type: 'array.offsiteMeeting', required: true },
        },
        extends: 'dbentity',
    };
    dailyLogSchema.push(schema);
}

{
    const schema = {
        doc: {
            name: 'dailyLogs',
            description: 'Data for daily log',
        },
        fields: {
            results: { type: 'array.dailyLog', required: true },
            count: { type: 'uint', required: true },
            next: { type: 'string' },
            previous: { type: 'string' },
        },
    };
    dailyLogSchema.push(schema);
}

{
    const schema = {
        doc: {
            name: 'offsiteMeeting',
            description: 'Data for offsite meeting',
        },
        fields: {
            id: { type: 'uint', required: true },
            location: { type: 'string', required: true },
            purpose: { type: 'string', required: true },
            date: { type: 'string', required: true },
            startTime: { type: 'string', required: true },
            endTime: { type: 'string', required: true },
            duration: { type: 'number', required: true },
            supervisor: { type: 'number', required: true },
            supervisorName: { type: 'string', required: true },
            alsoNotify: { type: 'number', required: false },
            alsoNotifyName: { type: 'string', required: false },
            approvalStatus: { type: 'string', required: false },
            log: { type: 'uint', required: true },
            approvalRemarks: { type: 'string' },
        },
        extends: 'dbentity',
    };
    dailyLogSchema.push(schema);
}

export default dailyLogSchema;
